import { FormControl, InputLabel, IconButton } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Calendar, CloseCircle } from "iconsax-react"; 
import dayjs from "dayjs";
import React from "react";
import "./_.scss";

const InputDate = ({ name, value, onChange = () => {}, format = 'DD/MM/YYYY', label, sx = {} }) => {
  const handleClear = () => {
    onChange(null); 
  };

  return (
    <FormControl>
      {label && <InputLabel>{label}</InputLabel>}
      <LocalizationProvider 
        dateAdapter={AdapterDayjs}
        localeText={{
          fieldMonthPlaceholder: (params) =>
            params.contentType === 'digit' ? 'MM' : 'MMM',
        }}
      >
        <DatePicker
          sx={sx}
          name={name}
          onChange={onChange}
          value={value ? dayjs(value) : null}
          format={format}
          className="date-picker"
          slots={{
            openPickerIcon: Calendar,
          }}
          slotProps={{
            popper: {
              className: "date-picker-vf1__popper",
            },
            textField: {
              inputProps: {
                placeholder: format, // Correctly adds the placeholder here
              },
              InputProps: {
                endAdornment: (
                  <IconButton 
                    onClick={handleClear} 
                    edge="end" 
                    color="secondary"
                    aria-label="clear"
                  >
                    <CloseCircle size={24} />
                  </IconButton>
                ),
              },
            },
            input: {
              endAdornment: (
                <IconButton 
                  onClick={handleClear} 
                  edge="end" 
                  color="secondary"
                  aria-label="clear"
                >
                  <CloseCircle size={24} />
                </IconButton>
              ),
            },
          }}
        />
      </LocalizationProvider>
    </FormControl>
  );
};

export default InputDate;